export default __webpack_public_path__ + "static/media/dockerhub.f8dcee51.svg";